//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateUsuarios } from "@/typings/store/plugins/easyFirestore/usuarios";

const getters: GetterTree<StateUsuarios, State> = {
  get(state) {
    return state.all;
  },
  getArray(state) {
    return Object.values(state.all);
  },
};

const usuarios = {
  firestorePath: "dev/v1/usuarios",
  firestoreRefType: "collection",
  moduleName: "usuarios",
  statePropName: "all",
  namespaced: true,
  serverChange: {
    convertTimestamps: {
      created_at: "%convertTimestamp%", // default
      updated_at: "%convertTimestamp%", // default
    },
  },
  state: {},
  getters,
  mutations: {},
  actions: {},
};

export default usuarios;
